import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { EmojiEvents, ArrowBack, School } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTraining } from '../hooks/useTraining';
import CertificateDisplay from '../components/CertificateDisplay';

export default function TrainingCertificatesPage() {
  const navigate = useNavigate();
  const { myCertificates, loading, error, fetchMyCertificates } = useTraining();

  useEffect(() => {
    loadCertificates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCertificates = async () => {
    try {
      await fetchMyCertificates();
    } catch (err) {
      console.error('Failed to load certificates:', err);
    }
  };

  if (loading && myCertificates.length === 0) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate('/training')}
        sx={{ mb: 3 }}
      >
        Back to Training
      </Button>

      {/* Header */}
      <Box mb={4} display="flex" alignItems="center" gap={2}>
        <EmojiEvents sx={{ fontSize: 40, color: 'primary.main' }} />
        <Box>
          <Typography variant="h4" gutterBottom fontWeight="bold">
            My Certificates
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your earned training certificates and achievements
          </Typography>
        </Box>
      </Box>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Certificates Grid */}
      {myCertificates.length === 0 ? (
        <Box textAlign="center" py={8}>
          <EmojiEvents sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No certificates yet
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Complete training courses to earn certificates
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/training')}
            startIcon={<School />}
          >
            Browse Courses
          </Button>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {myCertificates.map((certificate) => (
            <Grid item xs={12} md={6} key={certificate.id}>
              <CertificateDisplay certificate={certificate} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Stats */}
      {myCertificates.length > 0 && (
        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="text.secondary">
            You've earned {myCertificates.length} certificate
            {myCertificates.length !== 1 ? 's' : ''}
          </Typography>
        </Box>
      )}
    </Container>
  );
}

